import React, { useCallback } from 'react';
import { PiTruck, PiUser, PiBuilding } from 'react-icons/pi';
import { useParams } from 'react-router-dom';
import { Input, Textarea } from 'rizzui';
import useFetch from '../../../../hooks/useFetch';
import FormGroup from "../../../../layout/shared/form-group";
import moment from 'moment';
import { ClientService } from "../../../../services/clients/clientService";
import { ClientApiResponse } from "../../../../type/entities/client-type";

interface ClientInfoProps { }

const ClientInfo: React.FC<ClientInfoProps> = () => {

    // HOOKS
    
    const { id = '' } = useParams<{ id: string }>();
    const service = new ClientService();

    // DATA FETCHING

    // -----------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene los datos del cliente por ID
     *
     * @EN Gets the client data by ID
     */
    // -----------------------------------------------------------------------------------------------------
    const [data, loading] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await service.getClientById(id);
        return response.getResponseData() as ClientApiResponse;
    }, [id]));
    // -----------------------------------------------------------------------------------------------------

    // RENDER

    return (
        <>
            <div className="@container">
                <div className="grid gap-7 divide-y-2 divide-dashed divide-gray-200">
                    <FormGroup
                        title="Información General"
                        description="Datos generales del cliente"
                        className='pt-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-4"
                    >
                        <Input
                            disabled
                            label="Razón social"
                            className="md:col-span-1"
                            value={data?.companyName}
                        />

                        <Input
                            disabled
                            label="CIF/NIF"
                            className="md:col-span-1"
                            value={data?.cifNif}
                        />

                        <Input
                            disabled
                            label="Teléfono"
                            className="md:col-span-1"
                            value={data?.telephone}
                        />

                        <Input
                            disabled
                            label="Email"
                            className="md:col-span-1"
                            value={data?.email}
                        />

                        <Input
                            disabled
                            label="Fecha de Creación"
                            className="md:col-span-2"
                            value={data?.createdAt ? moment(data.createdAt.date).format('DD/MM/YYYY HH:mm') : ""}
                        />

                        <Input
                            disabled
                            label="Fecha de Actualización"
                            className="md:col-span-2"
                            value={data?.updatedAt ? moment(data.updatedAt.date).format('DD/MM/YYYY HH:mm') : ""}
                        />
                        
                        <Textarea
                            disabled
                            label="Dirección"
                            className="md:col-span-2"
                            value={data?.address}
                        />
                    </FormGroup>

                    <FormGroup
                        title="Organización"
                        description="Datos de la organización"
                        className='pt-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-3"
                    >
                        <Input
                            disabled
                            label="Nombre"
                            value={data?.company?.name ?? ""}
                        />
                        <Input
                            disabled
                            label="CIF"
                            value={data?.company?.cif ?? ""}
                        />
                    </FormGroup>
                </div>
            </div>
        </>
    );
};

export default ClientInfo;